
import { Vue, Options, prop } from "vue-class-component";

class Props {
  cargoType = prop<string>({
    default: "",
    type: String
  });
  origin = prop<string>({
    default: "",
    type: String
  });
  destination = prop<string>({
    default: "",
    type: String
  });
  departureDate = prop<string>({
    default: "",
    type: String
  });
}

// generate props
@Options({
  components: {}
})
class CargoV2EditHeaderTitle extends Vue.with(Props) {
  goBack() {
    this.$router.push("/cargo-v2/create");
  }
}
export default CargoV2EditHeaderTitle;
